// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"assignment-error"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M9.70802 2.5C10.0938 1.61705 10.9748 1 12 1C13.0252 1 13.9062 1.61705 14.292 2.5H20.5V21.5H3.5V2.5H9.70802Z","fill-rule":"evenodd","clip-rule":"evenodd"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M9.70802 2.5C10.0938 1.61705 10.9748 1 12 1C13.0252 1 13.9062 1.61705 14.292 2.5H20.5V21.5H3.5V2.5H9.70802Z","fill-rule":"evenodd","stroke-linecap":"square","stroke-width":2,"clip-rule":"evenodd"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12 8.5V12.5M12 15.9961H12.0039V16H12V15.9961Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-assignment-error')
export default class AssignmentErrorIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'assignment-error',
    }
  }
}
